export enum AttendanceReasonVisibilityGroup {
  FEE_FOR_LIFE = 'feeForLife',
  FEE_FOR_SERVICE = 'feeForService',
}

export enum SubReasonName {
  ABERTURA_DE_PLANO = 'ABERTURA_DE_PLANO',
  ABERTURA_DE_SUBFATURA = 'ABERTURA_DE_SUBFATURA',
  ACERTO_DE_IMPLANTACAO = 'ACERTO_DE_IMPLANTACAO',
  ACESSO_AO_APLICATIVO = 'ACESSO_AO_APLICATIVO',
  ADITIVOS = 'ADITIVOS',
  AJUSTES = 'AJUSTES',
  ALTERACAO_CADASTRAL = 'ALTERACAO_CADASTRAL',
  ALTERACAO_SENHA = 'ALTERACAO_SENHA',
  ANALISE_ISENCAO_DE_CARENCIA = 'ANALISE_ISENCAO_DE_CARENCIA',
  ANTECIPACAO_DE_FATURA = 'ANTECIPACAO_DE_FATURA',
  APLICATIVO = 'APLICATIVO',
  ARQUIVO_DE_CONTABILIZACAO = 'ARQUIVO_DE_CONTABILIZACAO',
  ARQUIVO_DE_RATEIO = 'ARQUIVO_DE_RATEIO',
  ATUALIZACAO_DE_INFORMACOES = 'ATUALIZACAO_DE_INFORMACOES',
  AUXILIO_NO_LOGIN = 'AUXILIO_NO_LOGIN',
  BASE_DE_ATIVOS = 'BASE_DE_ATIVOS',
  BASE_DE_VIDAS = 'BASE_DE_VIDAS',
  BLOQUEIO_DE_ACESSO = 'BLOQUEIO_DE_ACESSO',
  CAMPANHA_DE_ADESAO = 'CAMPANHA_DE_ADESAO',
  CANCELAMENTO = 'CANCELAMENTO',
  CANCELAMENTO_DE_CONTRATO = 'CANCELAMENTO_DE_CONTRATO',
  CANCELAMENTO_DE_ESTIPULANTE = 'CANCELAMENTO_DE_ESTIPULANTE',
  CANCELAMENTO_DE_MOVIMENTACAO = 'CANCELAMENTO_DE_MOVIMENTACAO',
  CANCELAMENTO_DE_SUBESTIPULANTE = 'CANCELAMENTO_DE_SUBESTIPULANTE',
  CANCELAMENTO_POR_INADIMPLENCIA = 'CANCELAMENTO_POR_INADIMPLENCIA',
  CARENCIA = 'CARENCIA',
  CARTA_DE_PERMANENCIA = 'CARTA_DE_PERMANENCIA',
  CARTOES_INFORMACAO = 'CARTOES_INFORMACAO',
  CARTOES_RENOVACAO = 'CARTOES_RENOVACAO',
  CASHBACK_QUESTIONAMENTO = 'CASHBACK_QUESTIONAMENTO',
  COBERTURA_ANS = 'COBERTURA_ANS',
  COMITE_DE_SAUDE = 'COMITE_DE_SAUDE',
  COMITE_OPERACIONAL = 'COMITE_OPERACIONAL',
  COMUNICACAO_MAIORIDADE = 'COMUNICACAO_MAIORIDADE',
  COMUNICADO_DE_SINISTRO_PARA_SEGURADORA = 'COMUNICADO_DE_SINISTRO_PARA_SEGURADORA',
  CONTA_MEDICA = 'CONTA_MEDICA',
  CONTATO_EQUIPE_INTERNA = 'CONTATO_EQUIPE_INTERNA',
  CONTATO_OPERADORA = 'CONTATO_OPERADORA',
  CONTROLE_E_ENVIO_DE_CARTOES = 'CONTROLE_E_ENVIO_DE_CARTOES',
  CONVERSAO_DE_ARQUIVOS = 'CONVERSAO_DE_ARQUIVOS',
  COPAY = 'COPAY',
  CRIACAO_DE_USUARIO = 'CRIACAO_DE_USUARIO',
  DESBLOQUEIO_DE_USUARIO = 'DESBLOQUEIO_DE_USUARIO',
  DOCUMENTACAO = 'DOCUMENTACAO',
  DUVIDA = 'DUVIDA',
  DUVIDA_DE_COBERTURA = 'DUVIDA_DE_COBERTURA',
  DUVIDA_DESCREDENCIAMENTO = 'DUVIDA_DESCREDENCIAMENTO',
  DUVIDA_MAIORIDADE = 'DUVIDA_MAIORIDADE',
  DUVIDA_REMISSAO = 'DUVIDA_REMISSAO',
  DUVIDAS = 'DUVIDAS',
  DUVIDAS_CONTRATUAIS = 'DUVIDAS_CONTRATUAIS',
  DUVIDAS_DE_FATURAMENTO = 'DUVIDAS_DE_FATURAMENTO',
  DUVIDA_SUBSIDIO_DE_MEDICAMENTOS = 'DUVIDA_SUBSIDIO_DE_MEDICAMENTOS',
  EMISSAO_DE_VOUCHER = 'EMISSAO_DE_VOUCHER',
  ENVIO_CERTIFICADO_SEGURO_VIDA = 'ENVIO_CERTIFICADO_SEGURO_VIDA',
  ENVIO_DE_COMUNICADOS = 'ENVIO_DE_COMUNICADOS',
  ENVIO_DE_FATURAMENTO = 'ENVIO_DE_FATURAMENTO',
  ENVIO_DE_FATURAMENTO_AO_CLIENTE = 'ENVIO_DE_FATURAMENTO_AO_CLIENTE',
  EXCLUSAO = 'EXCLUSAO',
  EXTENSAO_DE_BENEFICIO = 'EXTENSAO_DE_BENEFICIO',
  EXTRATO_DE_COPARTICIPACAO = 'EXTRATO_DE_COPARTICIPACAO',
  FATURA_TECNICA = 'FATURA_TECNICA',
  GYMPASS = 'GYMPASS',
  IMPORTACAO_BASE_SEGURO_VIDA = 'IMPORTACAO_BASE_SEGURO_VIDA',
  INCLUSAO = 'INCLUSAO',
  INCLUSAO_DE_DEMITIDOS_APOSENTADOS = 'INCLUSAO_DE_DEMITIDOS_APOSENTADOS',
  INCLUSAO_DE_REMIDOS = 'INCLUSAO_DE_REMIDOS',
  INCLUSAO_FORA_DO_PRAZO = 'INCLUSAO_FORA_DO_PRAZO',
  INDICACAO_DE_CREDENCIAMENTO = 'INDICACAO_DE_CREDENCIAMENTO',
  INFORMACAO = 'INFORMACAO',
  INFORMACOES = 'INFORMACOES',
  INFORMACOES_DE_REEMBOLSO = 'INFORMACOES_DE_REEMBOLSO',
  INFORME_RENDIMENTO = 'INFORME_RENDIMENTO',
  LIBERACAO_STATUS_DE_SENHA = 'LIBERACAO_STATUS_DE_SENHA',
  LIBERACAO_DE_PROCEDIMENTO = 'LIBERACAO_DE_PROCEDIMENTO',
  LIMINAR = 'LIMINAR',
  MATERIAL_INFORMATIVO = 'MATERIAL_INFORMATIVO',
  NAO_RECEBIMENTO_DO_CARTAO = 'NAO_RECEBIMENTO_DO_CARTAO',
  NEGATIVA_DE_PROCEDIMENTO = 'NEGATIVA_DE_PROCEDIMENTO',
  NEGATIVA_DE_USO_MEDICAMENTO = 'NEGATIVA_DE_USO_MEDICAMENTO',
  NUMERACAO_DE_CARTAO = 'NUMERACAO_DE_CARTAO',
  NUMERO_DA_CARTEIRINHA = 'NUMERO_DA_CARTEIRINHA',
  ORIENTACOES_SOBRE_LIBERACAO = 'ORIENTACOES_SOBRE_LIBERACAO',
  OUTRO = 'OUTRO',
  PEDIDO = 'PEDIDO',
  PREVIA_DE_REEMBOLSO = 'PREVIA_DE_REEMBOLSO',
  PROPOSTA_DE_ADESAO = 'PROPOSTA_DE_ADESAO',
  PRORROGACAO = 'PRORROGACAO',
  QV_ACOES_DE_SAUDE = 'QV_ACOES_DE_SAUDE',
  REAJUSTE = 'REAJUSTE',
  REATIVACAO = 'REATIVACAO',
  REATIVACAO_APOLICE = 'REATIVACAO_APOLICE',
  REDE_CREDENCIADA = 'REDE_CREDENCIADA',
  REEMBOLSO_REANALISE = 'REEMBOLSO_REANALISE',
  REFATURAMENTO = 'REFATURAMENTO',
  RELATORIOS_GERENCIAIS = 'RELATORIOS_GERENCIAIS',
  REMISSAO = 'REMISSAO',
  SEGUNDA_VIA = 'SEGUNDA_VIA',
  SEGURO_DE_VIDA = 'SEGURO_DE_VIDA',
  SOLICITACAO_DE_2_VIA_DE_CARTAO = 'SOLICITACAO_DE_2_VIA_DE_CARTAO',
  SOLICITAR_REEMBOLSO = 'SOLICITAR_REEMBOLSO',
  UPGRADE = 'UPGRADE',
}
